import { defineMessages } from 'react-intl';
export default defineMessages({
  close: {
    id: 'common.nav.close',
    defaultMessage: 'Close'
  },
  print: {
    id: 'common.nav.print',
    defaultMessage: 'Print'
  },
  fax: {
    id: 'common.nav.fax',
    defaultMessage: 'Fax'
  },
  facesheet: {
    id: 'common.nav.facesheet',
    defaultMessage: 'Facesheet'
  }
});